export default "__VITE_ASSET__DyVHMfs0__"